import { MAX_LENGTH } from '@/shared/constants/validationVars';

import {
  createMaxLengthRule,
  createMinLengthRule,
  createRegexMark,
} from '../validate';

export const reqOpenReason = {
  regex: [
    createRegexMark(
      'Только русские буквы, цифры, точка, запятая, слэш, тире, символ №',
      ' .,/№-',
      'а-яёА-ЯЁ0-9'
    ),
  ],
  minLength: createMinLengthRule(4),
  maxLength: createMaxLengthRule(MAX_LENGTH),
};
